import { ICreateProjetoImpressaoUseCase } from "../../../presentation/useCases/create/create_projeto_impressao_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * CreateProjetoImpressaoUseCase
 */

export class CreateProjetoImpressaoUseCase implements ICreateProjetoImpressaoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjeto?: number,
    idCentroCusto?: number,
    idFuncionarioSolicitante?: number,
    dataSolicitacao?: Date,
    quantidade?: number,
    cor?: number,
    tamanho?: string,
    observacoesSolicitacao?: string,
    disciplinasIds?: number[],

  ): Promise<number> {
    return await this.repository.createProjetoImpressao(
      idProjeto,
      idCentroCusto,
      idFuncionarioSolicitante,
      dataSolicitacao,
      quantidade,
      cor,
      tamanho,
      observacoesSolicitacao,
      disciplinasIds,

    );
  }
}
